// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
var defaultCmsPage = {
    isCreatingPage: false,
    isEditingPage: false,
    id: 0,
    isPublished: false,
    isDocPage: false,
    allowUnsanitizedHtml: false,
    isNewWorld: false
};
export var CmsPageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCmsPage, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createTime) {
            message.createTime = new Date(wireFormat.createTime);
        }
        return message;
    }
};
export var CreatePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDocsPage = {
    id: 0
};
export var DocsPageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDocsPage, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.createTime) {
            message.createTime = new Date(wireFormat.createTime);
        }
        return message;
    }
};
export var GetPageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetPagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetPagesResponse = {
    pages: []
};
export var GetPagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetPagesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return CmsPageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListDocsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListDocsResponse = {
    docsPages: []
};
export var ListDocsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListDocsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.docsPages) {
            message.docsPages = wireFormat.docsPages.map(function(i) {
                return DocsPageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListPagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.filter) {
            wireFormat.filter = CmsFilterByWireFormat3.toJson(message.filter);
        }
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = CmsGroupByWireFormat3.toJson(message.group);
        }
        if (message === null || message === void 0 ? void 0 : message.sort) {
            wireFormat.sort = CmsSortByWireFormat3.toJson(message.sort);
        }
        return wireFormat;
    }
};
var defaultListPagesResponse = {
    pages: []
};
export var ListPagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListPagesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return CmsPageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdateDocPageOrderRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdatePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdatePageResponse = {
    url: ""
};
export var UpdatePageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdatePageResponse, wireFormat);
        return message;
    }
};
export var CmsFilterBy;
(function(CmsFilterBy) {
    CmsFilterBy["UNSPECIFIED"] = "unspecified";
    CmsFilterBy["ALL"] = "all";
    CmsFilterBy["PUBLISHED"] = "published";
    CmsFilterBy["UNPUBLISHED"] = "unpublished";
})(CmsFilterBy || (CmsFilterBy = {}));
export var CmsFilterByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CmsFilterBy.UNSPECIFIED:
            case 0:
            default:
                return "CMS_FILTER_BY_UNSPECIFIED";
            case CmsFilterBy.ALL:
            case 1:
                return "CMS_FILTER_BY_ALL";
            case CmsFilterBy.PUBLISHED:
            case 2:
                return "CMS_FILTER_BY_PUBLISHED";
            case CmsFilterBy.UNPUBLISHED:
            case 3:
                return "CMS_FILTER_BY_UNPUBLISHED";
        }
    }
};
export var CmsGroupBy;
(function(CmsGroupBy) {
    CmsGroupBy["UNSPECIFIED"] = "unspecified";
    CmsGroupBy["ALL"] = "all";
    CmsGroupBy["DOCUMENTATION_PAGES"] = "documentationPages";
})(CmsGroupBy || (CmsGroupBy = {}));
export var CmsGroupByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CmsGroupBy.UNSPECIFIED:
            case 0:
            default:
                return "CMS_GROUP_BY_UNSPECIFIED";
            case CmsGroupBy.ALL:
            case 1:
                return "CMS_GROUP_BY_ALL";
            case CmsGroupBy.DOCUMENTATION_PAGES:
            case 2:
                return "CMS_GROUP_BY_DOCUMENTATION_PAGES";
        }
    }
};
export var CmsSortBy;
(function(CmsSortBy) {
    CmsSortBy["UNSPECIFIED"] = "unspecified";
    CmsSortBy["EARLIEST"] = "earliest";
    CmsSortBy["LATEST"] = "latest";
    CmsSortBy["DOC_PAGE_ORDER"] = "docPageOrder";
})(CmsSortBy || (CmsSortBy = {}));
export var CmsSortByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CmsSortBy.UNSPECIFIED:
            case 0:
            default:
                return "CMS_SORT_BY_UNSPECIFIED";
            case CmsSortBy.EARLIEST:
            case 1:
                return "CMS_SORT_BY_EARLIEST";
            case CmsSortBy.LATEST:
            case 2:
                return "CMS_SORT_BY_LATEST";
            case CmsSortBy.DOC_PAGE_ORDER:
            case 3:
                return "CMS_SORT_BY_DOC_PAGE_ORDER";
        }
    }
};
// CMS = Content Management System
export var cmsClient = {
    legacyCmsService: {
        // Creates a stub of a CMS page (but doesn't save it into the database).
        createPage: createClient(CreatePageRequestWireFormat3, CmsPageWireFormat3, "cms.LegacyCmsService/CreatePage"),
        // Gets a page by id or slug.
        getPage: createClient(GetPageRequestWireFormat3, CmsPageWireFormat3, "cms.LegacyCmsService/GetPage"),
        // Get pages by id.
        getPages: createClient(GetPagesRequestWireFormat3, GetPagesResponseWireFormat3, "cms.LegacyCmsService/GetPages"),
        // Lists all of the documentation pages (used by the outline sidebar).
        listDocs: createClient(ListDocsRequestWireFormat3, ListDocsResponseWireFormat3, "cms.LegacyCmsService/ListDocs"),
        // Lists all pages (documentation and regular CMS pages).
        listPages: createClient(ListPagesRequestWireFormat3, ListPagesResponseWireFormat3, "cms.LegacyCmsService/ListPages"),
        // Allows an admin to specify where on the documentation main page a doc
        // page should appear.
        updateDocPageOrder: createClient(UpdateDocPageOrderRequestWireFormat3, google.protobuf.EmptyWireFormat3, "cms.LegacyCmsService/UpdateDocPageOrder"),
        // Updates the metadata and content of a CMS/doc page.
        updatePage: createClient(UpdatePageRequestWireFormat3, UpdatePageResponseWireFormat3, "cms.LegacyCmsService/UpdatePage")
    }
};
